import { createAsyncThunk } from '@reduxjs/toolkit';

import { fluxosArbitralService, PublicacaoRecusadaError } from '../services/fluxosArbitralService';
import type {
  CreateFluxoArbitralInput,
  FalhaDePublicacao,
  FluxoArbitralListItem,
  LexiAtiva,
} from '../types';

interface ListarParams {
  busca?: string;
  status?: 'DRAFT' | 'ACTIVE' | 'ARCHIVED';
  page?: number;
  limit?: number;
}

export const fetchFluxosArbitrais = createAsyncThunk(
  'fluxosArbitrais/listar',
  async (params: ListarParams = {}, { rejectWithValue }) => {
    try {
      return await fluxosArbitralService.listar(params);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erro ao listar fluxos';
      return rejectWithValue(message);
    }
  },
);

export const fetchLexisAtivas = createAsyncThunk<LexiAtiva[], void, { rejectValue: string }>(
  'fluxosArbitrais/lexisAtivas',
  async (_, { rejectWithValue }) => {
    try {
      return await fluxosArbitralService.listarLexisAtivas();
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erro ao listar Lexis';
      return rejectWithValue(message);
    }
  },
);

export const criarFluxoArbitral = createAsyncThunk<
  FluxoArbitralListItem,
  CreateFluxoArbitralInput,
  { rejectValue: string }
>('fluxosArbitrais/criar', async (input, { rejectWithValue }) => {
  try {
    return await fluxosArbitralService.criar(input);
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Erro ao criar fluxo';
    return rejectWithValue(message);
  }
});

export const duplicarFluxoArbitral = createAsyncThunk<
  FluxoArbitralListItem,
  string,
  { rejectValue: string }
>('fluxosArbitrais/duplicar', async (fluxoId, { rejectWithValue }) => {
  try {
    return await fluxosArbitralService.duplicar(fluxoId);
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Erro ao duplicar fluxo';
    return rejectWithValue(message);
  }
});

export const publicarFluxoArbitral = createAsyncThunk<
  FluxoArbitralListItem,
  string,
  { rejectValue: FalhaDePublicacao }
>('fluxosArbitrais/publicar', async (fluxoId, { rejectWithValue }) => {
  try {
    return await fluxosArbitralService.publicar(fluxoId);
  } catch (error) {
    const mensagem = error instanceof Error ? error.message : 'Erro ao publicar fluxo';
    const problemas = error instanceof PublicacaoRecusadaError ? error.problemas : [];
    return rejectWithValue({ mensagem, problemas });
  }
});

export const arquivarFluxoArbitral = createAsyncThunk<
  FluxoArbitralListItem,
  string,
  { rejectValue: string }
>('fluxosArbitrais/arquivar', async (fluxoId, { rejectWithValue }) => {
  try {
    return await fluxosArbitralService.arquivar(fluxoId);
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Erro ao arquivar fluxo';
    return rejectWithValue(message);
  }
});
